import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "part-1-container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "carousel-inner" }
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/carousel-control-prev-icon.png",
  alt: "Previous",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["data-bs-target"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/carousel-control-next-icon.png",
  alt: "Next",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title"),
    _createElementVNode("div", {
      id: _ctx.id,
      class: "carousel slide w-100"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("button", {
        class: "carousel-control-prev",
        type: "button",
        "data-bs-target": `#${_ctx.id}`,
        "data-bs-slide": "prev"
      }, _hoisted_8, 8, _hoisted_5),
      _createElementVNode("button", {
        class: "carousel-control-next",
        type: "button",
        "data-bs-target": `#${_ctx.id}`,
        "data-bs-slide": "next"
      }, _hoisted_12, 8, _hoisted_9)
    ], 8, _hoisted_2)
  ]))
}